import { StoreState } from "../../../apps/containers/AppContainer/StoreState";

import AITweakActions from "../../../apps/data/aiTweak/AITweakActions";

import AITweakHelpers from "../../../apps/data/aiTweak/AITweakHelpers";

import AIReviewDotRating from "../../../foundation/api/model/AIReview/AIReviewDotRating";

import {
    StoreProps,
    RawProps,
    Props,
    OwnProps,
    DispatchProps
} from "./AITweakProps";

export function mapStateToProps(
    {
        BarrelStore: {
            barrelId
        },
        InspectableViewStore: {
            inspectableId,
            zoomLevel,
            approvalsId
        },
        AITweakDataStore: {
            tweaks
        }
    }: StoreState
): StoreProps {
    return {
        zoomLevel,
        barrelId,
        inspectableId,
        approvalsId,
        tweaks
    };
}

export function mapDispatchToProps(_dispatch: unknown, { pid, airid, sid }: OwnProps): DispatchProps {
    return {
        createAITweakInteraction(message: string) {
            AITweakActions.createAITweakInteraction({
                pid,
                airid,
                interaction: {
                    screen: sid,
                    message
                },
                syncWithApi: true
            });
        },
        getProjectAITweak(onSuccess: (chatCount: number) => void) {
            AITweakActions.getProjectAITweak(pid, airid, onSuccess);
        },
        saveAITweakChatHistory(chatText: string) {
            AITweakActions.saveAITweakChatHistory(pid, airid, chatText);
        },
        setAITweakChatRating(chatLineId: string, rating: AIReviewDotRating) {
            AITweakActions.setAITweakChatRating({
                pid, airid, chatLineId, rating, syncWithApi: true
            });
        },
        stopAITweak() {
            AITweakActions.stopAITweak({
                pid, airid
            });
        }
    };
}

export function transformProps(rawProps: RawProps): Props {
    const aiTweakData = AITweakHelpers.getAIReviewTweaks();

    return {
        ...rawProps,
        aiTweakData,
        barrelId: rawProps.barrelId
    };
}
